
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Menu, X, Search, User, LogOut } from "lucide-react";

const Header = ({ wallet }) => {
  const navigate = useNavigate();
  const username = localStorage.getItem("username");
  const [menuOpen, setMenuOpen] = useState(false);
  const [query, setQuery] = useState("");

  const handleLogout = () => {
    localStorage.removeItem("username");
    localStorage.removeItem("access");
    navigate("/home");
  };

  const handleSearch = (e) => {
    e.preventDefault();
    if (query.trim()) navigate(`/search?query=${query}`);
  };

  return (
    <header className="bg-white shadow-md sticky top-0 z-50">
      <div className="max-w-7xl mx-auto flex items-center justify-between px-4 sm:px-6 py-3">
        {/* Left: Hamburger + Logo */}
        <div className="flex items-center gap-3">
          <button
            onClick={() => setMenuOpen(!menuOpen)}
            className="p-2 hover:bg-gray-100 rounded-md transition"
          >
            {menuOpen ? <X size={22} /> : <Menu size={22} />}
          </button>
          <Link to="/" className="text-2xl font-bold text-indigo-600">
            CASHPAO
          </Link>
        </div>

        {/* Middle: Search Bar */}
        <form
          onSubmit={handleSearch}
          className="hidden sm:flex flex-1 max-w-lg mx-4"
        >
          <div className="flex items-center w-full border border-gray-300 rounded-full px-3 py-2">
            <Search className="text-gray-500 mr-2" size={18} />
            <input
              type="text"
              placeholder="Search for brands, stores or products..."
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              className="w-full outline-none text-gray-700"
            />
          </div>
        </form>

        {/* Right: Wallet + Login / Logout */}
<div className="flex items-center gap-4">
  {username && (
    <div className="hidden sm:flex items-center gap-6 bg-gray-50 px-4 py-2 rounded-lg border border-gray-200 shadow-sm">
      <div className="text-center">
        <p className="text-xs text-gray-500">Wallet</p>
        <p className="text-green-600 font-semibold text-sm">
          ₹{wallet?.total_confirmed || 0}
        </p>
      </div>
      <div className="text-center border-l border-gray-300 pl-4">
        <p className="text-xs text-gray-500">Cashback</p>
        <p className="text-indigo-600 font-semibold text-sm">
          ₹{wallet?.total_pending || 0}
        </p>
      </div>
    </div>
  )}

  {username ? (
    <>
      <span className="hidden sm:block text-gray-700">
        Hi, <span className="font-medium">{username}</span>
      </span>
      <button
        onClick={handleLogout}
        className="flex items-center gap-1 px-3 py-1.5 text-sm font-semibold text-red-600 border border-red-600 rounded-md hover:bg-red-600 hover:text-white transition"
      >
        <LogOut size={16} />
        Logout
      </button>
    </>
  ) : (
    <Link
      to="/login"
      className="flex items-center gap-1 px-3 py-1.5 text-sm font-semibold text-indigo-600 border border-indigo-600 rounded-md hover:bg-indigo-600 hover:text-white transition"
    >
      <User size={16} />
      Login
    </Link>
  )}
</div>

      </div>

      {/* Sidebar (Categories) */}
      <div
        className={`fixed top-0 left-0 h-full w-64 bg-white shadow-2xl transform transition-transform duration-300 ease-in-out ${
          menuOpen ? "translate-x-0" : "-translate-x-full"
        }`}
      >
        <div className="flex justify-between items-center p-4 border-b">
          <h2 className="text-lg font-bold text-gray-800">Categories</h2>
          <button
            onClick={() => setMenuOpen(false)}
            className="p-2 hover:bg-gray-100 rounded-md"
          >
            <X size={22} />
          </button>
        </div>

        <ul className="p-4 space-y-2 text-gray-700 font-medium">
  {[
    "Electronics",
    "Fashion",
    "Travel",
    "Food & Dining",
    "Grocery",
    "Beauty & Wellness",
    "Offers & Deals",
  ].map((cat) => (
    <li key={cat}>
      <Link
        to={`/category/${cat.toLowerCase().replace(/ & /g, "-")}`}
        onClick={() => setMenuOpen(false)}
        className="block py-2 px-2 rounded-md transition 
                   hover:bg-indigo-50 hover:text-indigo-600 
                   cursor-pointer select-none"
      >
        {cat}
      </Link>
    </li>
  ))}
</ul>
      </div>

      {/* Overlay */}
      {menuOpen && (
        <div
          className="fixed inset-0 z-40"
          onClick={() => setMenuOpen(false)}
        ></div>
      )}
    </header>
  );
};

export default Header;
